import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  checkUserStatus,
  kUserStatusLoggedIn,
  kUserStatusLoggedOut,
  kUserStatusPendingTerms,
  kUserStatusUnknown,
  selectUserStatus,
} from 'state/userSlice';

import { AppHeader } from 'features/app_header/AppHeader';

import './App.css';

export function useAppDispatchUserStatus() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const userStatus = useAppSelector(selectUserStatus);
  const { pathname } = useLocation();

  function maybeNavigate(target_pathname) {
    if (pathname !== target_pathname) {
      navigate({ pathname: target_pathname });
    }
  }

  useEffect(() => {
    if (userStatus === kUserStatusUnknown) {
      // if user status is unknown
      // ! TS2345: Argument of type 'AsyncThunkAction<any, void, AsyncThunkConfig>' is not assignable to parameter of type 'AnyAction'.
      // @ts-ignore
      dispatch(checkUserStatus());
    } else if (userStatus === kUserStatusLoggedIn) {
      // if user is logged in
      const searchParams = new URLSearchParams(window.location.search);
      if (
        !window.location.toString().includes('/app') &&
        !window.location.toString().includes('/manage') &&
        !window.location.toString().includes('/notifications')
      ) {
        navigate({
          pathname: '/app',
          search: searchParams.toString(),
        });
      }
    } else if (userStatus === kUserStatusLoggedOut) {
      // if user is logged out
      if (!['/sso', '/directlogin'].includes(pathname)) maybeNavigate('/login');
    } else if (userStatus === kUserStatusPendingTerms) {
      maybeNavigate('/terms');
    }
  }, [userStatus]);
}

export function AppDispatcher() {
  const userStatus = useAppSelector(selectUserStatus);
  // const searchParams = new URLSearchParams(window.location.search).toString();
  console.log(`AppDispatcher - userStatus: ${userStatus}`);
  useAppDispatchUserStatus();

  if (
    ![kUserStatusUnknown, kUserStatusLoggedIn, kUserStatusLoggedOut].includes(
      userStatus,
    )
  ) {
    return (
      <div className="App">
        <AppHeader />
        <div className="App-body">
          <div>
            userStatus:
            {userStatus}
            ...
          </div>
        </div>
      </div>
    );
  }
}
